export default {
  Studies: "Исследования",
  Layouts: "Окна",
  Sync: "Синхронизация",
  scroll: "Прокрутка",
  wwwc: "Уровни",
  zoom: "Зум",
  general: "Основные",
  zooming: "Зум",
  annotation: "Измерения",
  rotating: "Повороты",
  Pan: "Перемещение",
  Wwwc: "Уровни точкой",
  WwwcRegion: "Уровни полигоном",
  Magnify: "Лупа",
  Zoom: "Зум",
  Screen: "Скриншот",
  Rotate: "Повернуть",
  Flip: "Отразить",
  Reset: "Сброс",
  Eraser: "Ластик",
  ArrowAnnotate: "A - Подпись",
  Bidirectional: "Крест",
  Angle: "Угол",
  EllipticalROI: "E - Эллипс",
  FreehandRoi: "Кривая линия",
  Length: "L - Линейка",
  Probe: "Пометка точкой",
  RectangleRoi: "Прямоугольник",
  TextMarker: "Текстовые пометки",
  DragProbe: "Зонд",
  ScaleOverlay: "Шкалы",
  OrientationMarkers: "OrientationMarkers",
  Brush: "Произвольный путь",
  CircleScissors: "Эллипс",
  FreehandScissors: "Произвольная фигура",
  RectangleScissors: "Прямоугольник",
  Invert: "Инверсия",
  Clip: "Автопрокрутка",
  Series: "Серии",
  Report: "Отчет",
  patientId: "ID пациента",
  fullname: "ФИО",
  birthday: "Дата рождения",
  studyCreatedAt: "Дата исследования",
  old: "Возраст",
  patientSex: "Пол",
  "Result AI": "Результат ИИ-анализа",
  "Download dicom": "Скачать ИИ-серии",
  "Download report": "Скачать отчет",
  Loading: "Загрузка",
  Cached: "в кэше",
  male: "Муж",
  female: "Жен",
  Copy: "Cкопировать",
  "Copy ok": "Скопировано",
  "Copy error": "Не удалось скопировать текст",
  Anonymized: "Анонимизировано",
  StackScroll: "Прокрутка",
  "Result after upload message":
    "После обработки исследования вам будет доступен отчет",
  "Result ai error message":
    "Не удалось обработать исследование, попробуйте загрузить другое исследование",
  error: "Ошибка",
  "dcm cannot loading": "Не удалось загрузить .dcm файлы",
  "error read dcm": "Ошибка чтения исследования",
  ai: "ИИ исследование",
  original: "Исходное исследование",
  "How to use title": "Инструкция по использованию сервиса",
  "How to use": "Инструкция",
  "ai accept caption": "Верен ли результат данного ИИ-анализа?",
  "thx for feedback": "Спасибо за обратную связь!",
  SelectedAccept: { 1: "Вы отметили, что результат", 2: "ИИ-анализа" },
  "accept yes": "верен",
  "accept no": "неверен",
  "View title": "Исследование | " + process.env.VUE_APP_INSTALL_NAME,
  Share: "Поделиться",
  "Share done": "Готово",
  "Share about": "Ссылка скопирована в буфер обмена",
  "Cancel preset": "Сброс",
  Description: "Описание",
  "About study": "Ваш ответ",
  CheckReport: "Отправить",
  "Your description": "Ваш ответ",
  "Best description": "Эталонное описание",
  "Teacher comment": "Комментарий преподавателя",
  "Answer exist": "Завершено",
  "Answer not exist": "Нет ответа",
  from: "из",
  "Skip all": "Пропустить все",
  "Add screenshot": "Сделать скриншот",
  "About screen info":
    "Вы можете делать пометки и прикладывать скриншоты вьюера (слева), нажав на кнопку «Сделать скриншот». Или загрузить их с компьютера, нажав на скрепку.",
  "Screenshot doned": "Готово",
  PlanarFreehandROI: "R - Контур",
  MPR: "MPR",
  "Disable MPR First": "Отключите режим MPR",
  Crosshairs: "MIP и оси",
  "MPR: only for 2+": "MPR недоступен",
  "MPR: hpu tier == 0":
    "Ваше устройство недостаточно производительно для создания реконструкции",
  "MPR: modality not support": "MPR модальности <modality> не поддерживается",
  "Cannot loading screen -- adblock":
    "Не удалось загрузить скриншот. Пожалуйста, отключите расширения браузера, такие, как VPN и блокировщики рекламы",
  "Cannot loading screen -- s3 request":
    "Не удалось загрузить скриншот. Попробуйте позже еще раз или напишите в поддержку",
  "Cannot loading screen -- upload":
    "Не удалось загрузить скриншот. Попробуйте позже еще раз или напишите в поддержку",
  voi: "Яркость",
  camera: "Пан/зум",
  "Remove?": "Удалить?",
  Support: "Поддержка",
  "Support info": "Вы можете задать вопрос или сообщить о проблеме",
  "Send work?": "Завершить описание и отправить работу на проверку?",
  shareAIResult:
    "Посмотрите, как ИИ обработал исследование на Платформе “" +
    process.env.VUE_APP_INSTALL_NAME +
    "”:",
  "Edit study": "Редактирование ответа",
};
